// import "./wdyr";
import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import App from "./App";

import { HeadProvider } from "react-head";

import store from "./redux/store";

import { wireGlobalSyncHooks } from "./bootstrap/syncBootstrap";

import { StyledEngineProvider, CssBaseline } from "@mui/material";

import "./index.scss";

// index.js (or App bootstrap)
// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", () => {
//     navigator.serviceWorker.register("/sw.js").catch(console.error);
//   });
// }

const disposeSync = wireGlobalSyncHooks(() => {
  const st = store.getState();
  const u = st?.createUser?.user || {};
  return {
    systemName: u.systemName,
    authToken: u.authToken,
    syncToken: u.syncToken,
  };
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <CssBaseline />
      <Provider store={store}>
        <HeadProvider>
          <App />
        </HeadProvider>
      </Provider>
    </StyledEngineProvider>
  </React.StrictMode>
);

if (import.meta && import.meta.hot) {
  import.meta.hot.dispose(() => disposeSync && disposeSync());
}
